// frontend/src/pages/user/UserNotificationsPage.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FaTrash, FaCheckDouble, FaBell } from 'react-icons/fa';

const UserNotificationsPage = () => {
    const [notifications, setNotifications] = useState([]);
    const [loading, setLoading] = useState(true);

    const API_URL = process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:5000/api';
    const getCleanToken = () => localStorage.getItem('token')?.replace(/"/g, '');

    const fetchNotifications = async () => {
        try {
            const token = getCleanToken();
            const config = { headers: { Authorization: `Bearer ${token}` } };
            const { data } = await axios.get(`${API_URL}/extras/notifications`, config);
            setNotifications(data);
            setLoading(false);
        } catch (error) {
            console.error(error);
            setLoading(false);
        }
    };

    useEffect(() => { fetchNotifications(); }, []);

    // Okundu İşaretle
    const handleMarkRead = async (id) => {
        try {
            const token = getCleanToken();
            // IIS için ?_method=PUT (PUT isteği)
            await axios.post(`${API_URL}/extras/notifications/${id}?_method=PUT`, {}, { headers: { Authorization: `Bearer ${token}` } });
            // State güncelle (Tekrar fetch atmadan)
            setNotifications(prev => prev.map(n => n._id === id ? { ...n, isRead: true } : n));
        } catch (error) { console.error(error); }
    };

    // Sil (Gizle)
    const handleDelete = async (id) => {
        if (!window.confirm("Bu bildirimi silmek istiyor musunuz?")) return;
        try {
            const token = getCleanToken();
            // IIS için ?_method=DELETE
            await axios.post(`${API_URL}/extras/notifications/${id}?_method=DELETE`, {}, { headers: { Authorization: `Bearer ${token}` } });
            // Listeden çıkar
            setNotifications(prev => prev.filter(n => n._id !== id));
        } catch (error) { console.error(error); }
    };

    if (loading) return <div className="text-white p-8 animate-pulse">Yükleniyor...</div>;

    return (
        <div className="space-y-6">
            <h1 className="text-2xl font-bold text-white flex items-center gap-2">
                <FaBell className="text-primary"/> Bildirimler
            </h1>
            
            <div className="bg-gray-800 rounded-xl overflow-hidden border border-gray-700 shadow-lg">
                {notifications.length > 0 ? (
                    <div className="divide-y divide-gray-700">
                        {notifications.map(notif => (
                            <div key={notif._id} className={`p-4 flex flex-col md:flex-row justify-between items-start md:items-center gap-4 transition-colors ${!notif.isRead ? 'bg-primary/5 hover:bg-primary/10' : 'hover:bg-gray-700/50'}`}>
                                <div className="flex items-start gap-4 flex-1">
                                    <div className={`p-2 rounded-full ${notif.isRead ? 'bg-gray-700 text-gray-400' : 'bg-primary text-white shadow-lg shadow-primary/30'}`}>
                                        <FaBell />
                                    </div>
                                    <div>
                                        <h4 className={`font-bold text-sm ${notif.isRead ? 'text-gray-300' : 'text-white'}`}>{notif.title}</h4>
                                        <p className="text-xs text-gray-400 mt-1">{notif.message}</p>
                                        <span className="text-[10px] text-gray-500 mt-2 block">{new Date(notif.createdAt).toLocaleString('tr-TR')}</span>
                                    </div>
                                </div>
                                
                                <div className="flex items-center gap-2 self-end md:self-auto">
                                    {!notif.isRead && (
                                        <button 
                                            onClick={() => handleMarkRead(notif._id)} 
                                            className="text-xs bg-green-600/20 hover:bg-green-600 text-green-400 hover:text-white px-3 py-1.5 rounded-lg transition-all flex items-center gap-1 border border-green-600/30"
                                            title="Okundu İşaretle"
                                        >
                                            <FaCheckDouble /> Okundu
                                        </button>
                                    )}
                                    <button 
                                        onClick={() => handleDelete(notif._id)} 
                                        className="text-xs bg-red-600/20 hover:bg-red-600 text-red-400 hover:text-white px-3 py-1.5 rounded-lg transition-all flex items-center gap-1 border border-red-600/30"
                                        title="Sil"
                                    >
                                        <FaTrash /> Sil
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="p-10 text-center text-gray-500 flex flex-col items-center">
                        <FaBell size={40} className="mb-4 opacity-20" />
                        <p>Hiç bildiriminiz yok.</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default UserNotificationsPage;